import { render, staticRenderFns } from "./s-form-rating.vue?vue&type=template&id=608b6d94"
import script from "./s-form-rating.vue?vue&type=script&lang=js"
export * from "./s-form-rating.vue?vue&type=script&lang=js"
import style0 from "./s-form-rating.vue?vue&type=style&index=0&id=608b6d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports